import { useCallback, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LoaderCard, LoaderInner } from "../../../common/Loader";
import { ASSET_HOST_BASE_URL, otherParty } from "../../../../config";
import LangContext from "../../../../contexts/LangContext";
import { getDistrictSummary, getPercentage, getRegionPath, translate, translateNumber, translatePercentage } from "../../../../helper";
import { PATH_REGION } from "../../../../helper/mapPath";

import "./index.css";

const MapChart = (props) => {
  const { lang } = useContext(LangContext);
  const { pid } = props;
  const navigate = useNavigate();

  const showRegionInfo = useCallback((el) => navigate(getRegionPath(el.target.getAttribute("datapid"), el.target.getAttribute("datadid"), el.target.getAttribute("datarid")), { replace: true }), [navigate]);

  const handleMouseOver = (el) => {
    let opacity = 0.8;
    document.querySelectorAll(".sh-district-region").forEach((region, j) => {
      if (j % 3 === 1) {
        opacity = 0.8;
      } else if (j % 3 === 2) {
        opacity = 0.7;
      } else {
        opacity = 0.6;
      }
      region.querySelectorAll("path").forEach((path) => {
        path.style.opacity = opacity;
      });
    });

    const myClass = Array.from(el.target.classList).find((c) => c.startsWith("region-"));
    document.querySelectorAll("." + myClass).forEach((path) => {
      path.style.opacity = 1;
    });
    document.querySelector(".sh-dist-map-legend").innerHTML = el.target.getAttribute("datarname");
  };

  const handleMouseLeave = (el) => {
    let opacity = 0.8;
    document.querySelectorAll(".sh-district-region").forEach((region, j) => {
      if (j % 3 === 1) {
        opacity = 0.8;
      } else if (j % 3 === 2) {
        opacity = 0.7;
      } else {
        opacity = 0.6;
      }
      region.querySelectorAll("path").forEach((path) => {
        path.style.opacity = opacity;
      });
    });
  };

  const districtData = props.data;

  const { win, lead, totalWin, totalLead } = getDistrictSummary(districtData);

  useEffect(() => {
    let boxheight = document.querySelector("#sh-district-map-chart .sh-widget-card").offsetHeight * 1.3;
    let chartHeight = boxheight / 2.22;
    let mainPageHeight = document.querySelector("#district-win-pie").clientHeight;
    if (chartHeight === 0) {
      if (mainPageHeight === 0) {
        mainPageHeight = 300;
      }
      chartHeight = mainPageHeight - 20 + "px";
    } else {
      chartHeight = chartHeight + "px";
    }
  }, [win, lead, props, lang]);

  const districtPath = PATH_REGION.find((p) => p.id.split("-")[1] === pid).districts.find((d) => d.id === props.district.id);
  let opacity = 0.8;
  const totalVoter = props.district.regions.filter((r) => r.rtype === "federal").reduce((a, b) => a + b.total_voter, 0);
  const areaSqKm = props.district.regions.filter((r) => r.rtype === "federal").reduce((a, b) => a + b.area_sq_km, 0);
  const votingBooth = props.district.regions.filter((r) => r.rtype === "federal").reduce((a, b) => a + b.voting_booth, 0);
  const totalERN = props.district.regions.filter((r) => r.rtype === "federal").length;

  return (
    <section id="sh-district-map-chart" className="sh-district-map-chart">
      <div className="container pb-3">
        <div className="container-fluid card sh-card-map">
          {!props.fetched && <LoaderCard />}
          <div className="row" style={{ opacity: props.fetched ? "1" : 0.5 }}>
            <div className="col-md-12">
              <div className="sh-widget-card">
                <div className="sh-dist-map-legend"></div>
                <h3 className="text-center">
                  {props.district["name_" + lang]} <span className="total-er">{" (" + translate("total_ERN", lang) + ":" + translateNumber(totalERN, lang)})</span>
                </h3>
                <div className="row">
                  <div className="col-md-6">
                    <div className="sh-map-district">
                      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2550 1500" enableBackground="new 0 0 2550 1500" xmlSpace="preserve">
                        <defs>
                          <pattern id="pattern-national-park" patternUnits="userSpaceOnUse" width="6" height="6" patternTransform="rotate(45)">
                            <line x1="0" y="0" x2="0" y2="6" stroke="#194d33" strokeWidth="10" />
                          </pattern>
                        </defs>
                        <g id={districtPath.id} transform={districtPath.districtTransform} style={{ scale: 3 }}>
                          {districtPath.regions.map((r, j) => {
                            if (j % 3 === 1) {
                              opacity = 0.8;
                            } else if (j % 3 === 2) {
                              opacity = 0.7;
                            } else {
                              opacity = 0.6;
                            }
                            let strokeColor2 = "#FFFFFF";
                            return (
                              <g className="sh-district-region" key={j}>
                                {r.subregions.map((sr, k) => {
                                  const style = { ...sr.style };

                                  // if (props.tab === "federal") {
                                  //   style.strokeWidth = 0;
                                  //   // style.strokeOpacity = 0.1;
                                  // }

                                  // National Park data
                                  if (sr.data) {
                                    opacity = 1;
                                  }
                                  let fillColor = props.provinceColor;

                                  const strokeColor = strokeColor2 ? strokeColor2 : style && style.strokeWidth ? fillColor : "#FFFFFF";

                                  return (
                                    <g key={k}>
                                      <path
                                        id={"region-" + districtPath.id + "-" + sr.id}
                                        style={style}
                                        className={"district-" + districtPath.id + " region-" + districtPath.id + "-" + parseFloat(sr.id).toFixed(0)}
                                        stroke={strokeColor}
                                        fill={sr.data && sr.data.key === "NP" ? "url(#pattern-national-park)" : fillColor}
                                        d={sr.d}
                                        opacity={opacity}
                                        dataspecial={sr.data ? sr.data["value_" + lang] : ""}
                                        datapid={pid}
                                        datadid={districtPath.id}
                                        datarid={parseFloat(sr.id).toFixed(0)}
                                        datarname={props.district["name_" + lang] + ": " + translateNumber(props.tab === "provincial" ? sr.id : r.id, lang)}
                                        onMouseOver={!sr.data && sr.id ? handleMouseOver : () => {}}
                                        onMouseLeave={handleMouseLeave}
                                        onClick={!sr.data && sr.id ? showRegionInfo : () => {}}
                                      ></path>
                                    </g>
                                  );
                                })}
                              </g>
                            );
                          })}
                        </g>
                      </svg>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <table className="table table-bordered sh-table-party mt-5">
                      <tbody>
                        {!props.fetched ? (
                          <tr>
                            <td colSpan={3}>
                              <LoaderInner />
                            </td>
                          </tr>
                        ) : (
                          <>
                            <tr>
                              <td className="sh-bold">{translate("total_voter", lang)}</td>
                              <td className="">{translateNumber(totalVoter, lang)}</td>
                            </tr>
                            <tr>
                              <td className="sh-bold">{translate("area", lang)}</td>
                              <td className="">
                                {translateNumber(areaSqKm.toFixed(2), lang)} {translate("sq_km", lang)}
                              </td>
                            </tr>
                            <tr>
                              <td className="sh-bold">{translate("voting_booth", lang)}</td>
                              <td className="">{translateNumber(votingBooth, lang)}</td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="row d-none">
                  <div className="col-sm-6">
                    <h4 className="text-center">{translate("win", lang)}</h4>
                    <div id="district-win-pie" className="text-center hidden-xs"></div>
                    {win.map((w, i) => {
                      const party = props.parties.find((par) => par.code === w.party) || otherParty;
                      return (
                        <div key={i}>
                          <label className="sh-progress-bar-label" htmlFor="">
                            <img
                              src={ASSET_HOST_BASE_URL + "/images/parties/" + party.code.toUpperCase() + ".png"}
                              alt={party.code.toUpperCase()}
                              onError={({ currentTarget }) => {
                                currentTarget.onerror = null; // prevents looping
                                currentTarget.src = ASSET_HOST_BASE_URL + "/images/parties/O.png";
                              }}
                              className="pull-left sh-party-symbol"
                              width="20px"
                              height="20px"
                            />
                            <Link to={"/candidates" + (w.party === "O" ? "" : "/" + w.party) + "?lang=" + lang}>{party["short_name_" + lang] ? party["short_name_" + lang] : party["name_" + lang]}</Link>
                          </label>
                          <span className="pull-right data">{translateNumber(w.win, lang)}</span>
                          <div className="progress">
                            <div className="progress-bar" role="progressbar" style={{ width: getPercentage(w.win, totalWin), backgroundColor: party.color, opacity: 1 }}>
                              {translatePercentage(w.win, totalWin, lang)}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="col-sm-6">
                    <h4 className="text-center mob-padding">{translate("lead", lang)}</h4>
                    <div id="district-lead-pie" className="text-center hidden-xs"></div>

                    {lead.map((l, i) => {
                      const party = props.parties.find((par) => par.code === l.party) || otherParty;
                      return (
                        <div key={i}>
                          <label className="sh-progress-bar-label" htmlFor="">
                            <img
                              src={ASSET_HOST_BASE_URL + "/images/parties/" + party.code.toUpperCase() + ".png"}
                              alt={party.code.toUpperCase()}
                              onError={({ currentTarget }) => {
                                currentTarget.onerror = null; // prevents looping
                                currentTarget.src = ASSET_HOST_BASE_URL + "/images/parties/O.png";
                              }}
                              className="pull-left sh-party-symbol"
                              width="20px"
                              height="20px"
                            />
                            <Link to={"/candidates" + (l.party === "O" ? "" : "/" + l.party)}>{party["short_name_" + lang] ? party["short_name_" + lang] : party["name_" + lang]}</Link>
                          </label>
                          <span className="pull-right data">{translateNumber(l.lead, lang)}</span>
                          <div className="progress">
                            <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={{ width: getPercentage(l.lead, totalLead), backgroundColor: party.color, opacity: 1 }}>
                              {translatePercentage(l.lead, totalLead, lang)}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapChart;
